import { Link } from "react-router-dom"
import "./Footer.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInstagram, faFacebookF } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons"

const Footer = () => {

  return (
    <div>
      <div className="footer">
        <div className="footer-left" data-aos="fade-up"
          data-aos-duration="1000">
          <img src="./HomePhotos/Footer/avenueonelogo.png" alt="logo" />
          <p>
            Avenue One envisions creating developments that are not only visually distinctive, but also
            commercially intelligent, functionally strong, and built for long-term urban value.
          </p>
        </div>
        <div className="footer-mid" data-aos="fade-up"
          data-aos-duration="1000">
          <div>
            <img src="./HomePhotos/Footer/aro.png" alt="aro" />
            <Link to="/">Home</Link>
          </div>
          <div>
            <img src="./HomePhotos/Footer/aro.png" alt="aro" />
            <Link to="/square">Square</Link>
          </div>
          <div>
            <img src="./HomePhotos/Footer/aro.png" alt="aro" />
            <Link to="/park">Park</Link>
          </div>
          <div>
            <img src="./HomePhotos/Footer/aro.png" alt="aro" />
            <Link to="/swissresidencies">Swiss Residencies</Link>
          </div>
          {/* <div>
            <img src="./HomePhotos/Footer/aro.png" alt="aro" />
            <Link to="/orchird">Orchird</Link>
          </div> */}
          <div>
            <img src="./HomePhotos/Footer/aro.png" alt="aro" />
            <Link to="/gallery">Gallery</Link>
          </div>
          <div>
            <img src="./HomePhotos/Footer/aro.png" alt="aro" />
            <Link to="/about">About</Link>
          </div>
          <div>
            <img src="./HomePhotos/Footer/aro.png" alt="aro" />
            <Link to="/contact">Contact</Link>
          </div>
        </div>
        <div className="footer-right" data-aos="fade-up"
          data-aos-duration="1000">
          <div className="footer-right-top">
            <label htmlFor="contact">Contact us on:</label>
            <p style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "13px", fontWeight: "500" }}>
              UAN:
              <span style={{ fontSize: "12px", fontWeight: "300", color: "white" }}>
                0311 1100 564
              </span>
            </p>
          </div>
          <div className="footer-right-bottom">
            <p>Follow us on:</p>
            <Link to="https://www.facebook.com/share/1K8GrR9vjj/" target="_blank">
              <FontAwesomeIcon icon={faFacebookF} className="footer-bottom-iconF" />
            </Link>
            <Link to="https://www.instagram.com/theavenueonepk?stkn=MWhwbTNrYXh0OW5jbg==/" target="_blank">
              <FontAwesomeIcon icon={faInstagram} className="footer-bottom-icon" />
            </Link>
            <Link target="_blank" to="https://www.linkedin.com/company/avenueonepk">
              <FontAwesomeIcon icon={faLinkedinIn} className="footer-bottom-icon" />
            </Link>
            <Link target="_blank" to="/contact">
              <FontAwesomeIcon icon={faEnvelope} className="footer-bottom-icon" />
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom" >
        <p>© 2026 Avenue One Residences All Copyrights Reserved,Designed by <Link to='https://hilighter.co/' target="_blank">Hilighter</Link> </p>
      </div>
    </div>
  );
};

export default Footer